<template>
  <div class="hotel-edit-accordion-2">
    <div class="form--row form--row__info">
      <!-- EMAIL -->
      <PmwFormInput
        :value="email"
        :error="errors.includes('EmailRemetente')"
        :required="true"
        :infoIcon="true"
        data-error="EmailRemetente"
        tooltipMinWidth="255"
        infoText="E-mail de contato do hotel que será exibido ao hóspede. Este e-mail também será utilizado como remetente nos e-mails de confirmação da reserva e afins."
        label="E-mail"
        placeholder="Insira o e-mail"
        class="form--input__email"
        @input="$emit('changeEmail', $event)"
      />

      <!-- INFORMAÇÕES -->
      <PmwParagraph class="form--info" size="paragraph-40">
        É imprescindível que seja feita a devida configuração de SPF para que o
        Letsbook possa realizar os envios automáticos utilizando o e-mail do
        hotel. <br />
        A entrada de registro do DNS deve conter o seguinte registro:
        <b>include:_spf.pmweb.com.br ~all</b>. <br />
        Em caso de dúvidas, entre em contato com o departamento de TI.
      </PmwParagraph>
    </div>

    <!-- TELEFONE 1 -->
    <PmwHeading size="paragraph-80" weight="weight-light" class="form--title">
      Telefone 01
    </PmwHeading>

    <div class="form--row">
      <!-- PAÍS TELEFONE -->
      <PmwFormSelect
        :value="displayCountry1"
        :options="ddi"
        :search="true"
        :required="!isSpecialPhone1"
        :disabled="isSpecialPhone1"
        label="País/Região"
        placeholder=""
        class="form--input form--input__phone-country"
        @input="$emit('changeCountry1', $event)"
      />

      <!-- DDD -->
      <PmwFormInput
        :value="prefix1"
        :error="errors.includes('Telefone1.DDD')"
        :required="!isSpecialPhone1"
        :disabled="isSpecialPhone1"
        :hasMask="true"
        :mask="country1 && country1.number === '55' ? '##' : '#####'"
        data-error="Telefone1.DDD"
        label="Prefixo"
        placeholder="00"
        class="form--input__prefix"
        @input="$emit('changePrefix1', $event)"
      />

      <!-- NÚMERO DE TELEFONE -->
      <PmwFormInput
        :value="number1"
        :error="
          errors.includes('Telefone1.Numero') ||
            isSpecialPhone1Invalid ||
            isRegularPhone1Invalid
        "
        :required="true"
        :hasMask="true"
        :mask="phone1Mask"
        :infoIcon="true"
        :placeholder="isSpecialPhone1 ? '0800 000 0000' : '0 0000-0000'"
        :class="
          isSpecialPhone1
            ? 'form--input__phone-number-special'
            : 'form--input__phone-number'
        "
        :infoText="phone1InfoText"
        data-error="Telefone1.Numero"
        tooltipMinWidth="179"
        label="Telefone"
        @input="handleNumber1Input"
      />
    </div>

    <!-- TELEFONE 2 -->
    <PmwHeading size="paragraph-80" weight="weight-light" class="form--title">
      Telefone 02
    </PmwHeading>

    <div class="form--row mb-0">
      <!-- PAÍS TELEFONE -->
      <PmwFormSelect
        :value="country2"
        :options="ddi"
        :search="true"
        label="País/Região"
        placeholder=""
        class="form--input form--input__phone-country"
        @input="$emit('changeCountry2', $event)"
      />

      <!-- DDD -->
      <PmwFormInput
        :value="prefix2"
        :error="errors.includes('Telefone2.DDD')"
        :hasMask="true"
        :mask="country2 && country2.number === '55' ? '##' : '#####'"
        data-error="Telefone2.DDD"
        label="Prefixo"
        placeholder="00"
        class="form--input__prefix"
        @input="$emit('changePrefix2', $event)"
      />

      <!-- NÚMERO DE TELEFONE -->
      <PmwFormInput
        :value="number2"
        :error="errors.includes('Telefone2.Numero')"
        :hasMask="true"
        :mask="
          country2 && country2.number === '55'
            ? ['####-####', '#####-####']
            : '###############'
        "
        :infoIcon="true"
        data-error="Telefone2.Numero"
        tooltipMinWidth="179"
        infoText="Telefone de contato do hotel que será exibido ao hóspede."
        label="Celular"
        placeholder="0 0000-0000"
        class="form--input__phone-number"
        @input="$emit('changeNumber2', $event)"
      />

      <!-- WHATSAPP -->
      <InputCheckbox
        :value="whatsapp"
        :checked="whatsapp"
        :inputValue="1"
        label="Whatsapp"
        name="whatsapp"
        @input="$emit('changeWhatsapp', $event)"
      />
    </div>
  </div>
</template>

<script>
import PmwHeading from '@solucoes/components-lib-tmp/src/components/elements/PmwHeading'
import PmwParagraph from '@solucoes/components-lib-tmp/src/components/elements/PmwParagraph'
import PmwFormInput from '@solucoes/components-lib-tmp/src/components/patterns/PmwFormInput'
import PmwFormSelect from '@solucoes/components-lib-tmp/src/components/patterns/PmwFormSelect'
import InputCheckbox from '@solucoes/components-lib-tmp/src/components/elements/InputCheckbox'

export default {
  name: 'ContactInformation',
  components: {
    PmwHeading,
    PmwParagraph,
    PmwFormInput,
    PmwFormSelect,
    InputCheckbox
  },
  props: {
    email: {
      type: String,
      default: null
    },

    /** Telefone 1: DDI */
    country1: {
      type: Object,
      default: () => {}
    },

    /** Telefone 1: DDD */
    prefix1: {
      type: [String, Number],
      default: null
    },

    /** Telefone 1: Número */
    number1: {
      type: [String, Number],
      default: null
    },

    /** Telefone 2: DDI */
    country2: {
      type: Object,
      default: () => {}
    },

    /** Telefone 2: DDD */
    prefix2: {
      type: [String, Number],
      default: null
    },

    /** Telefone 2: Número */
    number2: {
      type: [String, Number],
      default: null
    },

    /** Se o número 2 é um Whatsapp */
    whatsapp: {
      type: Boolean,
      default: false
    },

    /** Erros (array de erros que foram identificados pelo back-end) */
    errors: {
      type: Array,
      default: () => []
    },

    /** Países formatados para o ddi */
    ddi: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    /**
     * Verifica se o Telefone 1 é um número especial (0800, 0900, 0300)
     * Esses números não possuem DDD e têm 11 dígitos
     */
    isSpecialPhone1() {
      if (!this.number1) return false
      const cleanNumber = String(this.number1).replace(/\D/g, '')
      return /^0[389]00/.test(cleanNumber)
    },

    /**
     * País exibido no select
     * Para números especiais (0800/0900/0300), mostra Brasil fixo
     * @returns {Object|null} Objeto do país para exibição
     */
    displayCountry1() {
      if (this.isSpecialPhone1) {
        /** Números 0800/0900/0300 são padrão brasileiro */
        return (
          this.ddi.find((item) => item.number === '55') || {
            text: 'Brasil (+55)',
            value: '+55',
            number: '55'
          }
        )
      }
      return this.country1
    },

    /**
     * Máscara dinâmica para o Telefone 1
     * - Número especial (0800/0900/0300): 11 dígitos (0800 000 0000)
     * - Brasil normal: 8-9 dígitos (####-#### ou #####-####)
     * - Outros países: até 15 dígitos
     */
    phone1Mask() {
      /** Números especiais sempre usam máscara de 11 dígitos */
      if (this.isSpecialPhone1) {
        return '#### ### ####'
      }

      const isBrazil = this.country1 && this.country1.number === '55'

      if (!isBrazil) {
        return '###############'
      }

      return ['####-####', '#####-####']
    },

    /**
     * Texto informativo dinâmico para o campo de telefone
     */
    phone1InfoText() {
      if (this.isSpecialPhone1Invalid) {
        return 'Números 0800, 0900 ou 0300 devem ter 11 dígitos.'
      }
      if (this.isSpecialPhone1) {
        return 'Números 0800, 0900 ou 0300 não requerem DDD.'
      }
      if (this.isRegularPhone1Invalid) {
        return 'O telefone deve ter 8 ou 9 dígitos.'
      }
      return 'Telefone de contato do hotel que será exibido ao hóspede.'
    },

    /**
     * Verifica se o número especial (0800/0900/0300) está incompleto
     * Retorna true se for um número especial com menos de 11 dígitos
     */
    isSpecialPhone1Invalid() {
      if (!this.isSpecialPhone1) return false
      const cleanNumber = String(this.number1).replace(/\D/g, '')
      return cleanNumber.length < 11
    },

    /**
     * Verifica se o telefone comum (não especial) está com quantidade inválida de dígitos
     * Para Brasil: deve ter 8 ou 9 dígitos
     * Retorna true se inválido
     */
    isRegularPhone1Invalid() {
      /** Números especiais têm validação própria */
      if (this.isSpecialPhone1) return false
      if (!this.number1) return false

      const cleanNumber = String(this.number1).replace(/\D/g, '')

      /** Se não há número digitado, não mostra erro (campo obrigatório trata isso) */
      if (cleanNumber.length === 0) return false

      /** Para Brasil, telefone deve ter 8 ou 9 dígitos */
      const isBrazil = this.country1 && this.country1.number === '55'
      if (isBrazil) {
        return cleanNumber.length < 8 || cleanNumber.length > 9
      }

      /** Para outros países, qualquer quantidade é válida */
      return false
    }
  },

  watch: {
    /**
     * Quando detectar que é um número especial, limpar o DDD
     * O país é mostrado como Brasil fixo via displayCountry1
     * @param {Boolean} isSpecial - Se o número é especial (0800/0900/0300)
     */
    isSpecialPhone1(isSpecial) {
      if (isSpecial) {
        /** Limpa DDD para números especiais */
        this.$emit('changePrefix1', '')
      }
    }
  },

  methods: {
    /**
     * Handler para input do número de telefone 1
     * Emite o evento de mudança para o componente pai
     * @param {String} value - Valor do telefone digitado pelo usuário
     */
    handleNumber1Input(value) {
      this.$emit('changeNumber1', value)
    }
  }
}
</script>

<style lang="scss" scoped>
.reference-tour {
  position: relative;
}

.pmw-form-field {
  ::v-deep {
    .pmw-form-field--label {
      font-weight: font-weight('weight-medium');
    }
    .form-field--label-wrapper {
      line-height: 21px;
      margin-bottom: 3px;
    }
    .pmw-input {
      background: $white;
    }
    .pmw-input--clear {
      z-index: 0;
    }
    .pmw-input__focus {
      border-color: $pmw-blue;
    }

    .pmw-input--field {
      background: $pmw-white;

      &:focus {
        border-color: $pmw-blue;
      }
    }

    .pmw-custom-tooltip {
      line-height: 18px;
    }
  }
}

.form {
  &--input {
    max-width: 248px;

    /** Alterar cores novas do select */
    ::v-deep {
      .pmw-select--button__caret-sort-up,
      .pmw-select--button__show {
        border-bottom-color: pmw-colors('blue-100');
      }
      .pmw-select--button:focus {
        border-color: pmw-colors('blue-100');
        border-bottom-color: pmw-colors('blue-100');
      }
      .pmw-select-options--item__hover:hover,
      .pmw-select-options--item__checked {
        background-color: pmw-colors('blue-100') !important;
      }

      .pmw-label {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    &__email {
      max-width: 377px;
    }

    &__phone-country {
      max-width: 193px;
    }

    &__prefix {
      max-width: 76px;
    }

    &__phone-number {
      max-width: 137px;
    }

    &__phone-number-special {
      max-width: 160px;
    }

    &__select {
      width: 250px;
      max-width: 250px;

      &.error {
        ::v-deep {
          .pmw-select--button {
            border-bottom-color: pmw-colors('error-100');
            border-bottom-width: 2px;
          }
        }
      }
    }
  }

  &--info {
    line-height: 18px;
    flex: 1;
    background: #fff5e9;
    color: pmw-colors('grey-90');
    padding: 16px;
    max-width: 567px;
    width: 100%;

    b {
      font-weight: font-weight('weight-medium');
      color: pmw-colors('blue-100');
    }
  }

  &--row {
    display: flex;
    align-items: flex-end;
    flex-wrap: wrap;
    gap: 54px;
    margin-bottom: 42px;

    &__info {
      align-items: center;
      gap: 63px;
    }
  }

  &--title {
    color: pmw-colors('blue-100');
    font-weight: font-weight('weight-medium');
    margin-bottom: 24px;
    position: relative;
  }
}

.pmw-input-checkbox ::v-deep {
  span {
    overflow: initial;
  }
}
</style>
